import BoubleText, {
  BubbleType,
} from '../../../../component/bubble-text/bouble-text';
import React from 'react';
import GreenDocIcon from '../../../../assets/icons/icon-doc-green.svg';
import BlueDocIcon from '../../../../assets/icons/icon-doc-blue.svg';
import { Chart } from 'primereact/chart';
import dateFormat from '../../../../utils/date-format';
import dateUtils from '../../../../utils/date-format';

interface itemDataModel {
  assignmentName: string;
  dueDate: Date;
  assignmentWeight: number;
  isCompletionGrade: boolean;
}
interface TestAndExamDataModel {
  exams: itemDataModel[];
  assignments: itemDataModel[];
}

const getItemListElement = (
  data: itemDataModel[],
  isExam: boolean,
  docIcon: any,
  assignmentsPoints: number,
) => {
  return (
    <div>
      {data.map((item) => (
        <div>
          <div
            style={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'row',
              marginTop: 20,
              justifyContent: 'space-between',
            }}
          >
            <div className={'general-course-page-card-row'}>
              <img src={docIcon} width={45} height={45} />
              <div style={{ width: 10 }} />
              <div className={'general-course-page-card-column'}>
                <div style={{ fontWeight: 'bold', fontSize: 16 }}>
                  {item.assignmentName}
                </div>
                {!isExam && (
                  <div style={{ color: '#6A6A6A', fontSize: 14 }}>
                    עד ה{dateFormat.displayFormatDate(item.dueDate)}
                  </div>
                )}
              </div>
            </div>
            {!isExam && (
              <BoubleText
                text={`${dateUtils.isDatePass(item.dueDate) ? 'סגורה להגשה' : 'פתוח להגשה'}`}
                type={
                  dateUtils.isDatePass(item.dueDate)
                    ? BubbleType.RED
                    : BubbleType.GREEN
                }
              />
            )}
          </div>
          <div
            style={{
              display: 'inline',
              color: '#666666',
              fontSize: 14,
              marginTop: 8,
            }}
          >
            {isExam ? 'מבחן' : 'מטלה'} זו מהווה{' '}
            <span style={{ color: '#3C9E62', display: 'inline' }}>
              {item.assignmentWeight}%
            </span>{' '}
            מכלל הציון
          </div>
        </div>
      ))}
    </div>
  );
};

const TestAndExam: React.FC<{ data: TestAndExamDataModel }> = ({ data }) => {
  const examPoints = data.exams.reduce(
    (sum, exam) => sum + exam.assignmentWeight,
    0,
  );

  const assignmentsPoints = data.assignments.reduce(
    (sum, assignmentItem) => sum + assignmentItem.assignmentWeight,
    0,
  );

  const chartData = {
    labels: ['מטלות', 'מבחנים'],
    datasets: [
      {
        data: [assignmentsPoints, 100 - assignmentsPoints],
        backgroundColor: ['#4CAF50', '#3F51B5'],
        hoverBackgroundColor: ['#45a049', '#383f9d'], // slightly darker shades for hover
      },
    ],
  };

  const chartOptions = {
    cutout: '60%', // controls the size of the center hole
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  return (
    <div>
      <div className={'general-course-page-card'}>
        <div
          className={'general-course-page-card-row'}
          style={{ justifyContent: 'space-between' }}
        >
          <div className={'general-course-page-card-title'}>מטלות</div>
        </div>

        {getItemListElement(
          data.assignments,
          false,
          GreenDocIcon,
          assignmentsPoints,
        )}

        <div style={{ paddingTop: 40 }} />

        <div
          className={
            'general-course-page-card-line general-course-page-card-row-height-space'
          }
        ></div>

        <div style={{ paddingTop: 40 }} />

        <div
          className={'general-course-page-card-row'}
          style={{ justifyContent: 'space-between' }}
        >
          <div className={'general-course-page-card-title'}>מבחנים</div>
        </div>

        {getItemListElement(data.exams, true, BlueDocIcon, assignmentsPoints)}

        <div
          style={{ marginTop: '35px' }}
          className={'general-course-page-card-line'}
        ></div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: '35px',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
            }}
          >
            <div style={{ fontSize: 18 }}>מבנה הציון</div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{ width: 5, height: 5, backgroundColor: '#35abb6' }}
                />
                <div style={{ width: 10, marginTop: '65px' }} />
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <div>מטלות</div>
                  <div>{assignmentsPoints}%</div>
                </div>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  marginRight: '30px',
                }}
              >
                <div
                  style={{ width: 5, height: 5, backgroundColor: '#35abb6' }}
                />
                <div style={{ width: 10, marginTop: '65px' }} />
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <div>מבחנים</div>
                  <div>{examPoints}%</div>
                </div>
              </div>
            </div>
          </div>

          <Chart
            style={{ width: '100px', height: '100px' }}
            type="doughnut"
            data={chartData}
            options={chartOptions}
            className="w-full md:w-30rem"
          />
        </div>
      </div>
    </div>
  );
};

export default TestAndExam;
